<template>
  <div class="coin-record">
    <!-- <header-link :link="headerLink"></header-link> -->
    <div class="coin-record-header">
      <span
        :class="{ active: isActive === 1}"
        @click="setActive(1)"
        v-if="permissions['Coin_Record_Org']"
      >組別賬戶</span>
      <span class="line" v-if="permissions['Coin_Record_Org']"></span>
      <span
        :class="{ active: isActive === 2}"
        @click="setActive(2)"
        v-if="permissions['Coin_Record_Individual']"
      >個人賬戶</span>
      <!-- <span
        @click="setActive(item.id)"
        v-for="item in headerLink"
        :key="item.id"
        :class="{ active: isActive === item.id}"
      >{{item.name}}</span>-->
    </div>
    <div class="coin-main">
      <!-- <router-view></router-view> -->
      <org-account v-if="isActive === 1"></org-account>
      <personal-account v-if="isActive === 2"></personal-account>
    </div>
  </div>
</template>
<script>
import headerLink from "./components/headerLink";
import orgAccount from "./record/organization";
import personalAccount from "./record/personal";
import { mapState } from "vuex";
export default {
  name: "coinRecord",
  components: {
    headerLink,
    orgAccount,
    personalAccount
  },
  data() {
    return {
      // headerLink: [
      //   {
      //     name: "組別賬戶",
      //     id: 1,
      //     permissionsCode: "Coin_Record_Org"
      //   },
      //   {
      //     name: "個人賬戶",
      //     id: 2,
      //     permissionsCode: "Coin_Record_Individual"
      //   }
      // ],
      isActive: 0,
      roleId: 0
      // currentPermission: ["Coin_Record_Org", "Coin_Record_Individual"] //组织账户,个人账户
    };
  },
  created() {
    if (this.permissions["Coin_Record_Org"]) {
      this.isActive = 1;
    } else if (
      !this.permissions["Coin_Record_Org"] &&
      this.permissions["Coin_Record_Individual"]
    ) {
      this.isActive = 2;
    }
    // if (
    //   this.permissions["Coin_Record_Org"] &&
    //   !this.permissions["Coin_Record_Individual"]
    // ) {
    //   this.headerLink.splice(1, 1);
    //   this.isActive = this.headerLink[0].id;
    // }
    // if (
    //   !this.permissions["Coin_Record_Org"] &&
    //   this.permissions["Coin_Record_Individual"]
    // ) {
    //   this.headerLink.splice(0, 1);
    //   this.isActive = this.headerLink[0].id;
    // } else {
    //   this.isActive = this.headerLink[0].id;
    // }
  },
  methods: {
    setActive(val) {
      this.isActive = val;
    }
  },
  computed: {
    ...mapState(["userInfo", "permissions"])
  }
  // beforeRouteEnter(to, from, next) {
  //   // ...
  //   next(vm => {
  //     if (vm.roleId === 3) {
  //       vm.$router.push("/coin/record/organization");
  //     } else {
  //       vm.$router.push("/coin/record/personal");
  //     }
  //   });
  // }
};
</script>
<style lang="less" scpoed>
@import "../../assets/css/element-reset.less";
.coin-record {
  text-align: left;
  // height: 100%;
  .coin-record-header {
    padding-bottom: 24px;
    span {
      display: inline-block;
      // margin-right: 60px;
      font-size: 24px;
      color: #92929d;
      letter-spacing: 0.1px;
      cursor: pointer;
    }
    span.active {
      color: #171725;
    }
    .line {
      width: 1px;
      height: 22px;
      background-color: #979797;
      position: relative;
      top: 3px;
      margin: 0 14px;
    }
  }
  .coin-main {
    padding-bottom: 20px;
  }
}
</style>